export default __webpack_public_path__ + "static/media/linux.a674aca8.svg";